<template>
    <div>
        <div class="form-group p-0-14">
            <div class="enum-attribute" v-if="attribute">
                <label class="attribute-label" :for="id">{{ attribute.attribute_name }}</label>
                <ul>
                    <li v-for="(value,index) of attribute.attribute_values" :key="index" @click="onClick(value)"
                        :class="[{'selected':value && selected && value.attribute_value_id == selected.attribute_value_id } ,'new-inputs']">

                        <span class="attribute-value">
                            {{ value.attribute_value }}
                        </span>

                        <!-- :TODO replace the height of the input if price doesn't exist -->
                        <span class="cost-attribute" style="text-align: left;">
                            $30.00 per hour
                        </span>
                    </li>
                </ul>
            </div>
            <div v-if="selected && selected.hasOwnProperty('attribute_value_id')" class="display-none">
                <input type="radio" :name="name" :id="`${id}-${selected.attribute_value_id}`"  :value="selected.attribute_value_id">
            </div>
        </div>
        <div class="form-group p-0-14" v-if="dependency.length > 0">
            <div class="dependent-attribute" v-for="(dependent,index) of dependency" :key="dependent.attribute_id">
                <attribute  v-model="dependency[index]"
                            :date-format="dateFormat"
                           :time-format="timeFormat"
                           :attribute="dependent"
                           :currency="currency"
                           :unit="unit"
                           :clone="clone"
                           :attributes="attributes">
                </attribute>
            </div>
        </div>
    </div>
</template>

<script>

import {EventBus} from "@/events/event-bus";

export default {
    name: "EnumAttribute",
    props: {
        attributes: {
            type: Array,
            default() {
                return []
            }
        },
        attribute: {
            type: Object,
            required: true
        },
        value: {},
        dateFormat: null,
        timeFormat: null,
        clone: 0
    },
    data() {
        return {
            selected: {}
        }
    },
    computed: {
        /**
         * gets all dependencies of the selected attribute
         * @returns {T[]|*[]}
         */
        dependency() {
            if (this.selected && this.selected.dependency) {
                return this.attributes.filter(attribute => this.selected.dependency.includes(attribute.attribute_id))
            }
            return []
        },
        /**
         * get attribute input id
         * @returns {string}
         */
        id() {
            if (parseInt(this.clone)) {
                return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
            }

            return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}`;
            // return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}`;
        },
        /**
         * get attribute input name
         * @returns {string}
         */
        name() {
            if (parseInt(this.clone)) {
                return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}[]`;
            }

            return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}`;
            // return `attribute_${this.attribute.service_id}${this.attribute.attribute_id}_${this.clone}[]`;
        }
    },
    methods: {
        /**
         * pick a value
         * @param value
         */
        onClick(value) {
            this.selected = value
            this.$emit('input', this.selected);
            EventBus.$emit('onCustomFieldUpdated', {
                attribute: this.attribute,
                value: this.selected
            })
        }
    }
}
</script>

<style scoped>
.display-none {
    display: none;
}
</style>